var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};






/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*================================ ============================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      
       setTimeout(function(){
             $(".upsell-ajax-cart").removeAttr("style");       
		 },1000);
      
      
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    //console.log(cart);
    console.log(cart.items);
    
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
    
    if(cart.item_count == 0){
      $('#CartDrawer .drawer__header .drawer__title').hide();
    }else{
      $('#CartDrawer .drawer__header .drawer__title').show();      
    }
    
    var subscriptionTotal= 0;
    $.each(cart.items, function(i, item) {
      if(cart.items[i].product_title == 'NAIL SUBSCRIPTION BOX - JOIN THE MANI X ME MONTHLY CLUB' || 
         cart.items[i].product_title == 'JOIN THE MANI X ME MONTHLY CLUB SUBSCRIPTION BOX' || 
         cart.items[i].product_title == "JOIN THE MANI X ME MONTHLY EXPRESS KIT SUBSCRIPTION" || 
         cart.items[i].product_title == "NAIL SUBSCRIPTION BOX - JOIN THE MANI X ME MONTHLY CLUB - 3 Months" || 
         cart.items[i].product_title == "NAIL SUBSCRIPTION BOX - JOIN THE MANI X ME MONTHLY CLUB - 6 Months" || 
         cart.items[i].product_title == "JOIN THE MANI X ME MONTHLY EXPRESS KIT SUBSCRIPTION - 3 Months" || 
         cart.items[i].product_title == "JOIN THE MANI X ME MONTHLY EXPRESS KIT SUBSCRIPTION - 6 Months"){
        subscriptionTotal ='1';
      }
    });
    
    if(subscriptionTotal == 0){
    	$('.subscription_product').remove();
    }else{
    	$('.regular_product').remove();
    }
                   // var d1 = document.getElementsByClassName('drawer__header')[0];
                    //d1.insertAdjacentHTML('afterBegin', '<span id="shipping_message_in_ajax" style="display:inline-block;width:100%;text-align:center;">We Pay US Shipping On Qualifying Order Over $40</span>');
                /*var no_of_product = document.querySelectorAll(".ajaxcart__row").length;
                var shipping_message_in_ajax = document.getElementById("shipping_message_in_ajax");
                if(shipping_message_in_ajax){
                  document.getElementById("shipping_message_in_ajax").remove();
                }
                if(no_of_product > 0){
                  var cartfreeshipping = 40.00;
                  var totalCart = $('.carto').html();
                  totalCart = totalCart.replace('$', '');
                  totalCart = totalCart.replace('USD', '');
                  var remain = cartfreeshipping - parseFloat(totalCart);
                  remain = remain.toFixed(2);
                  if(remain > 0){
                    $('.shipping_total span.cartcolor').text('$4.95');
                    var value_new = parseFloat(totalCart) + 4.95;
                    value_new = value_new.toFixed(2);
                    $('#CartDrawer #CartContainer .cart .ajaxcart__footer .shiptextcarttotal .total .cartcolor.carto').text("$ "+value_new+" USD");
                    var d1 = document.getElementsByClassName('drawer__header')[0];
                    d1.insertAdjacentHTML('afterBegin', '<span id="shipping_message_in_ajax" style="display:inline-block;width:100%;text-align:center;">$' + remain + ' more to free USA shipping</span>');

                  } else {
                    $('.shipping_total span.cartcolor').text('Free ');
                    var d12 = document.getElementsByClassName('drawer__header')[0];
                    d12.insertAdjacentHTML('afterBegin', '<span id="shipping_message_in_ajax" style="display:inline-block;width:100%;text-align:center;"><span class="emoji" style="font-size: 16px; position: relative; top: 2px;">🎉</span> You\'ve earned free USA shipping! <span class="emoji" style="font-size: 16px; position: relative; top: 2px;">🎉</span></span>');
                  }
                } else {
                  var d123 = document.getElementsByClassName('drawer__header')[0];
                  //d123.insertAdjacentHTML('afterBegin', '<span id="shipping_message_in_ajax" style="display:inline-block;width:100%;text-align:center;">ORDERS OVER $35.00 SHIPS FREE ANYWHERE IN THE USA</span>');
                }*/
    //console.log(cart.item_count);
    //$(".top-bar a.mini_cart span.cart_count").text("("+cart.item_count+")");
    //$("#header .top-bar .cart-container span.cart_count.mob-show").text(cart.item_count);
    $('#headerIconVariation .Cartcount').text(cart.item_count);
    $('span.counter.CartCount').text(cart.item_count);
    if( cart.item_count == 0 || cart.item_count == 1 ){
      
      $("#CartDrawer").find(".itemcount").text(" Item");

    }
   
    else
    {
      
      $("#CartDrawer").find(".itemcount").text(" Items");

    } 
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      
     // console.log('yesyes');
      
    
    var subscriptionTotal= 0, giftTotal= 0;
    $.each(cart.items, function(i, item) {
      console.log(cart.items[i].product_title);
      if(cart.items[i].product_title == 'NAIL SUBSCRIPTION BOX - JOIN THE MANI X ME MONTHLY CLUB' || 
         cart.items[i].product_title == 'JOIN THE MANI X ME MONTHLY CLUB SUBSCRIPTION BOX' || 
         cart.items[i].product_title == "JOIN THE MANI X ME MONTHLY EXPRESS KIT SUBSCRIPTION" || 
         cart.items[i].product_title == "NAIL SUBSCRIPTION BOX - JOIN THE MANI X ME MONTHLY CLUB - 3 Months" || 
         cart.items[i].product_title == "NAIL SUBSCRIPTION BOX - JOIN THE MANI X ME MONTHLY CLUB - 6 Months" || 
         cart.items[i].product_title == "JOIN THE MANI X ME MONTHLY EXPRESS KIT SUBSCRIPTION - 3 Months" || 
         cart.items[i].product_title == "JOIN THE MANI X ME MONTHLY EXPRESS KIT SUBSCRIPTION - 6 Months"){
        subscriptionTotal += cart.items[i].quantity;
      }
      if(cart.items[i].product_title == "1st Month MxM Free Gift Promo - Ice Cube Clear Rectangular Stamper w/ Scraper Card"){
        giftTotal += cart.items[i].quantity;
      }
    });
    console.log(subscriptionTotal);
    console.log(giftTotal);
    
    // if(giftTotal != subscriptionTotal && giftTotal < subscriptionTotal){
    //   var total_quant = subscriptionTotal - giftTotal;
    //   console.log(total_quant);
    //   if(total_quant > 0){
    //     console.log('yes');
    // 	var data = {
    //         quantity: total_quant,
    //         id: '12414693638244'
    //     };
    //     $.ajax({
    //         type: "POST",
    //         url: "/cart/add.js",
    //         data: data,
    //         dataType: "json",
    //         success: function() {
              
    //         }
    //     });
    //   }
    // }else if(giftTotal > subscriptionTotal){
    // 	var data = {
    //         quantity: subscriptionTotal,
    //         id: '12414693638244'
    //     };
    //     $.ajax({
    //         type: "POST",
    //         url: "/cart/change.js",
    //         data: data,
    //         dataType: "json",
    //         success: function() {
              
    //         }
    //     });
    // }
    
      setTimeout(function(){    
      
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      /*if(cart.item_count > 0){
        $(".upsell-ajax-cart").removeAttr("style");
      }
      else{
        $(".upsell-ajax-cart").attr("style","display:none");
      }*/
        
        },2000);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      	$cartCountSelector.html(cart.item_count).removeClass('hidden-count');
		$("#CartCountbubble").html(cart.item_count);
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
      //$cartCostSelector.html(Shopify.formatMoney(cart.total_price, ));
      
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
//       $addToCart.removeClass('is-added').addClass('is-adding');
      $addToCart.find('span[data-add-to-cart-text]').hide();
      $addToCart.removeClass('is-added').addClass('is-adding').append('<span class="addingToCart">Adding To Cart...</span>').attr("disabled", true);

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
//     $addToCart.removeClass('is-adding').addClass('is-added');
      $addToCart.find('span[data-add-to-cart-text]').show();
    $addToCart.removeClass('is-adding').addClass('is-added').attr("disabled", false);
    $addToCart.find('.addingToCart').remove();

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        //.append('<p>' + "Your cart is empty.  Add an item to start your creative journey with us now : )" + '</p>');
      	.append('<p> Your cart is currently empty. </p>');
    $(".top-bar a.mini_cart span.cart_count").text("("+cart.item_count+")");
    $("#header .top-bar .cart-container span.cart_count.mob-show").text(cart.item_count);
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      //totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
  
    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function() {
        if (isUpdating) {
            return;
        }

        var $el = $(this),
            line = $el.data('line'),
            qty = 0;

        // Remove all items of this type from the cart
        if (line) {
            updateQuantity(line, qty);
        }

    });
    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
 
      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          //if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
